import { makeStyles, Spinner } from "@fluentui/react-components";
import { getDiagnostics } from "apps/diagnostics/api";
import { DiagnosticsLayout } from "apps/diagnostics/components/DiagnosticsLayout";
import { ManageDiagnostics } from "apps/diagnostics/components/manageDiagnostics/ManageDiagnostics";
import { IDiagnostic } from "apps/diagnostics/models/IDiagnostic";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setDiagnostics } from "../redux/diagnosticsSlice";

const useStyles = makeStyles({
  loadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    flex: "1",
  },
});

export const DiagnosticsPage = (): JSX.Element => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchDiagnostics = async () => {
      try {
        setIsLoading(true);
        const data: IDiagnostic[] = await getDiagnostics();
        dispatch(setDiagnostics(data));
      } catch (error) {
        console.error("Failed to fetch diagnostics", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDiagnostics();
  }, [dispatch]);

  return (
    <DiagnosticsLayout>
      {isLoading ? (
        <div
          className={styles.loadingContainer}
          role="status"
          aria-live="polite"
        >
          <Spinner size="large" label="Loading diagnostics..." />
        </div>
      ) : (
        <ManageDiagnostics />
      )}
    </DiagnosticsLayout>
  );
};
